import React from "react";
import "../Privacy/style.css"

export default function TermsPage() {
  return (
    <div className="privacy">
      <div className="container privacy__container">

        <h1 className="privacy__title">Terms & Conditions</h1>
        <p className="privacy__updated">Last Updated: March 2026</p>

        <section className="privacy__section">
          <p>
            Welcome to BioClock-in. These Terms and Conditions (“Terms”) govern
            your use of the BioClock-in website, software, biometric devices,
            and related services. By accessing or using our services, you agree
            to be bound by these Terms.
          </p>
        </section>

        <section className="privacy__section">
          <h2>1. Services Overview</h2>
          <p>
            BioClock-in provides biometric clock-in and workforce management
            solutions designed to help businesses manage employee attendance,
            working hours, leave tracking, and reporting.
          </p>
        </section>

        <section className="privacy__section">
          <h2>2. Client Responsibilities</h2>
          <ul>
            <li>Provide accurate information when using the system</li>
            <li>Ensure lawful use of employee and biometric data</li>
            <li>Obtain employee consent where required by law</li>
            <li>Maintain confidentiality of login credentials</li>
            <li>Use the system only for legitimate business purposes</li>
          </ul>
        </section>

        <section className="privacy__section">
          <h2>3. Biometric Data Usage</h2>
          <p>
            BioClock-in uses biometric authentication such as fingerprint
            templates for identity verification.
          </p>
          <ul>
            <li>We do not store fingerprint images</li>
            <li>Only encrypted templates are stored</li>
            <li>Data is used strictly for authentication purposes</li>
          </ul>
        </section>

        <section className="privacy__section">
          <h2>4. Data Ownership</h2>
          <p>
            All employee and attendance data entered into the system remains
            the property of the client organization. BioClock-in acts as a data
            processor on behalf of the client.
          </p>
        </section>

        <section className="privacy__section">
          <h2>5. Fees and Payments</h2>
          <p>
            Hardware devices may be sold as a once-off purchase, while software
            services may be charged on a subscription basis (for example per
            employee). Failure to make payments may result in suspension of
            services.
          </p>
        </section>

        <section className="privacy__section">
          <h2>6. Device Usage</h2>
          <p>
            Clients agree to use devices according to provided instructions.
            BioClock-in is not responsible for damage caused by misuse,
            unauthorized modifications, accidents, or environmental factors.
          </p>
        </section>

        <section className="privacy__section">
          <h2>7. System Availability</h2>
          <p>
            We aim to provide reliable services, including offline functionality
            where applicable. However, uninterrupted or error-free operation
            cannot be guaranteed.
          </p>
        </section>

        <section className="privacy__section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, BioClock-in shall not be
            liable for indirect or consequential losses, payroll errors caused
            by incorrect input, or damages exceeding the amount paid for the
            services.
          </p>
        </section>

        <section className="privacy__section">
          <h2>9. Intellectual Property</h2>
          <p>
            All software, branding, and technology related to BioClock-in remain
            the intellectual property of BioClock-in. Clients receive a limited
            right to use the services during the subscription period.
          </p>
        </section>

        <section className="privacy__section">
          <h2>10. Termination</h2>
          <p>
            Services may be suspended or terminated if terms are violated,
            payments are overdue, or misuse occurs. Clients may terminate
            according to agreed contractual terms.
          </p>
        </section>

        <section className="privacy__section">
          <h2>11. Privacy</h2>
          <p>
            Use of BioClock-in services is also governed by our Privacy Policy.
          </p>
        </section>

        <section className="privacy__section">
          <h2>12. Compliance with Laws</h2>
          <p>
            Clients agree to comply with all applicable laws including labour
            regulations, employment laws, and data protection laws such as POPIA
            in South Africa.
          </p>
        </section>

        <section className="privacy__section">
          <h2>13. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of the Republic of South
            Africa.
          </p>
        </section>

        <section className="privacy__section">
          <h2>14. Contact Information</h2>
          <div className="privacy__contact">
            <p><strong>BioClock-in</strong></p>
            <p>Email: support@bioclock-in.com</p>
            <p>Website: www.bioclock-in.com</p>
          </div>
        </section>

      </div>
    </div>
  );
}